import { Helpers } from '../../helpers';
import { ICostCodeCostTypeProjectCombination } from '../../interfaces/icost-code-cost-type-project-combination';
import { CostCodeCostType } from '../cost-code-cost-type';
import { ProjectType } from '../project-type';
import { ResourceCostCodeCostType } from '../resource-cost-code-cost-type';
import { ScheduleActivityCostCodeCostType } from '../schedule-activity-cost-code-cost-type';
import { StandardConfigurationDetail } from '../standard-configuration-detail';

export class CostCodeCostTypeProjectCombinationBase {
  CostCodeCostTypeProjectCombinationId: number;
  ProjectTypeId: number;
  CostCodeCostTypeId: number;
  IsActive: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ResourceCostCodeCostTypes_CostCodeCostTypeProjectCombination?: Array<ResourceCostCodeCostType> | null;
  ScheduleActivityCostCodeCostTypes_CostCodeCostTypeProjectCombination?: Array<ScheduleActivityCostCodeCostType> | null;
  StandardConfigurationDetails_CostCodeCostTypeProjectCombination?: Array<StandardConfigurationDetail> | null;
  CostCodeCostType?: CostCodeCostType;
  ProjectType?: ProjectType;

  constructor(item?: ICostCodeCostTypeProjectCombination) {
    if (item) {

      this.CostCodeCostTypeProjectCombinationId = item.CostCodeCostTypeProjectCombinationId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.CostCodeCostTypeId = item.CostCodeCostTypeId;
      this.IsActive = item.IsActive;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ResourceCostCodeCostTypes_CostCodeCostTypeProjectCombination = Helpers.createClassArray(ResourceCostCodeCostType, item.ResourceCostCodeCostTypes_CostCodeCostTypeProjectCombination);
      this.ScheduleActivityCostCodeCostTypes_CostCodeCostTypeProjectCombination = Helpers.createClassArray(ScheduleActivityCostCodeCostType, item.ScheduleActivityCostCodeCostTypes_CostCodeCostTypeProjectCombination);
      this.StandardConfigurationDetails_CostCodeCostTypeProjectCombination = Helpers.createClassArray(StandardConfigurationDetail, item.StandardConfigurationDetails_CostCodeCostTypeProjectCombination);
      this.CostCodeCostType = new CostCodeCostType(item.CostCodeCostType);
      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}